var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 86,
    viewBox: "0 0 79 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 86,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_115_1155",
    transform: "matrix(0.0170095 0 0 0.015625 -0.0443038 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_115_1155",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAADuUlEQVR4nO2bW4hNYRTHf2OYaTKIchlmBvNgEnIpUkMkyV2UIkqoKSTzoDyYB2Fq3qSGCfPgEkryQPHgHiOT8eCSXHKXYsaD24wxxtZX62g37XOcffb69jnHOf9aL3P2fGt9v/Ptb6+1vn0gq6yyysqOegEzgG3A8RjXvQRuAifk2jlAIWmqHsBsmcwXwHFZNDke1gFcBjYA/UgD5QDLgAdRJuQXgNu+A/VACSmqMuBiHBOJJidO+wHUAgWkkBYDn+OcQFAAEXsKTCIFtAn47SNwLQDG2oAVJFEbfU5eG4CxLmAtSdBc4FcCAWsDiEBYGuLcGQK0JBisDQCO7EHlYQE4EyBQWwCM3ZYcxKpmBQzSJgBjlbYB3EhxAO+APFuTn6IQoG0AxtbYArA/TQBctZXnf0gTAObxPFgbQLlScGEAMLZSG8C6NAOwRxtAQ5oBuKIN4LrSvRkWgCfaAB4GzNVNM6M0xvgHEyisYtlXbQDvAwQyL04fi6ThoQHgpzaAjgS/+fk+/axWWgmd2gDaEwjCLPtEdEABgGmWqKo1gW8g1j0fS6WyeoIAeK08f+75DKAxoL/GgADuoKzTPgOoC+hvX0AArdqd460+A6gJ6K9GYR/YgaIm+HRuNrJoKonj0VivAMA8UsdqQnjssz3lpZlSVZoe3sgYvpoUABi7K+eTKqr04bjL4xirR7eOkjkMzfXwMyLBjrP1WyFPHi/xOj7kMcYA4L7rmmqLhZc7K5yqBWG9z1WwxGOMIuC5K7jJ3dpumjVBxF5onTDnANd8OP4WBUKZq74wlVtv+Xs+8MgCAGMnUewOtftcCQ0emeE44JPHU6NCIROMZqaxk5S8wJGl3SSlrzniPgq8cn3uXil1lgCoZYi5wC3l4D7KsZtRH+CNhckXo6iJFpbqedlnjBYqbYhvgS1RHrmBdcTCMq1yjb8zwDjPJPGyMnH3bq69CkwStOCvB9gs9b3fcbzyECu6ZGEVmJeiVrl8DAN2y4ob3s1/sdw63ccw4EJRlQUAETssqfG/VOLxv+b9xFBUYRGAI/3IU/IqTKEPAP3DAjDIMgC3nQOGekz+gu2WWCzlhwggXjtLyHJSzHZlOoDlmQ5gVCYDaLOd/XnJSSEzFWfoclLEzA8vxmcigBbZ+fsmY/KENMkiKZGrpaFSK/m+qfh6kmQ5IVhKy8kCILNXQIEUKWOAafK6S6WcyuyVBqgpZJqlHd75vwHwK9P3GwiMBqbLDx4MsO3yjt8xqfCapbIzDZKsssoKK/oDjF/p2B3rCkAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e996c9361863e506a1a39dab558de137.svg";
export { ForwardRef as ReactComponent };